import { render, staticRenderFns } from "./Heritage.vue?vue&type=template&id=073f75ce&"
import script from "./Heritage.vue?vue&type=script&lang=js&"
export * from "./Heritage.vue?vue&type=script&lang=js&"
import style0 from "./Heritage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports